<div class="card">
  <div class="card-header card-header-squirrel">
    <h4>{{this.translate.data['ADDTENANTGROUPROLE'] | translate}}</h4>
  </div>
  <div class="card-body">
    <form [formGroup]="groupRoleForm" novalidate>

      <div class="row">
        <div class="col-md-4">
          <mat-form-field class="example-full-width">
            <input type="text" matInput placeholder="{{this.translate.data['TENANTGROUPROLENAME'] | translate}}" formControlName="name" required>
            <!-- <mat-error *ngIf="!groupRoleForm.controls['name'].valid && groupRoleForm.controls['userName'].touched"> {{this.translate.data['ERRORALERT'] | translate}} </mat-error> -->
            @if (!groupRoleForm.controls['name'].valid && groupRoleForm.controls['name'].touched) {
              <mat-error> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <tenant-permissions-list [permissions]=""  [tenantRoles]="" (onChangeEvent)="onChange($event)"></tenant-permissions-list>

      <!-- <div class="row" *ngIf="admin">
      <div class="col-md-12">
        <mat-form-field class="example-full-width">
          <mat-select placeholder="Select a Tenant" formControlName="tenant"  multiple>
            <mat-option *ngFor="let item of tenants" [value]="item">
              {{item.displayName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div> -->

    <div class="row">
      <!-- <button matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}" mat-button (click)="cancel()" >
      <mat-icon>close</mat-icon>
    </button>
    <span style="flex: 1 1 auto"></span>
    <button matTooltip="{{this.translate.data['ADDTENANTGROUPROLE'] | translate}}" mat-button (click)="add()">
      <mat-icon>add</mat-icon>
    </button> -->
    <a>
      <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
      (click)="cancel()" >Abbruch</button>
    </a>
    <span style="flex: 1 1 auto"></span>
    <a>
      <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['ADDTENANTGROUPROLE'] | translate}}"
      (click)="add()" [disabled]="!isFormValid()">Hinzufügen</button>
    </a>

  </div>
</form>
</div>
</div>

